/**
 * Design-tokens — PARK 2.0 (park-branding), Montserrat.
 *
 * Brandflader, tekst, kanter og knapper bruger KUN paletten nedenfor.
 * Rainy (#EDEEEF) erstatter farvekortets Mist efter PARK's eget valg.
 * Undtagelse (bevidst valg): signalfarverne warning/error/info til status og fejl.
 */
export const PARK = {
  sage: '#CCE5C1',
  forrest: '#1C4C40',
  rainy: '#EDEEEF',
  stone: '#4B4A48',
  softCloud: '#F5F6F8',
} as const;

export const T = {
  // Flader
  bg: PARK.rainy, surface: PARK.softCloud, tertiary: PARK.rainy,
  headerBg: PARK.sage, headerFg: PARK.forrest,
  dark: PARK.forrest, onDark: PARK.softCloud, onDarkMuted: PARK.sage,
  // Tekst — Forrest til overskrifter/primær tekst, Stone til brød- og sekundær tekst
  fg: PARK.forrest, fg2: PARK.stone, fg3: PARK.stone,
  // Accent / CTA
  accent: PARK.forrest, accentHover: PARK.forrest, accentLight: PARK.sage, onAccent: PARK.softCloud,
  // Kanter og neutrale spor (progress, chips)
  border: PARK.sage, borderLight: PARK.rainy, track: PARK.rainy,
  disabledBg: PARK.rainy, disabledFg: PARK.stone,
  // Status — success i palette; warning/error/info er bevarede signalfarver
  success: PARK.forrest, successBg: PARK.sage,
  warning: '#d4a574', warningFg: '#a9743a', warningBg: 'rgba(212,165,116,0.16)',
  error: '#c44536', errorFg: '#9a3528', errorBg: 'rgba(196,69,54,0.10)', errorBorder: 'rgba(196,69,54,0.3)',
  info: '#3a6ea5', infoBg: 'rgba(58,110,165,0.10)',
  // Modal-baggrund (Forrest, halvgennemsigtig)
  scrim: 'rgba(28,76,64,0.45)',
  font: '"Montserrat", Arial, sans-serif',
} as const;
